import { render } from "./subcategory.vue?vue&type=template&id=78b044b0"
import script from "./subcategory.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./subcategory.vue?vue&type=script&charset=utf-8&lang=js"

import "./subcategory.vue?vue&type=style&index=0&id=78b044b0&lang=scss"

import exportComponent from "/home/th3g3ntl3man/github/blog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__